import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "login-container" }
const _hoisted_2 = { class: "login-form" }
const _hoisted_3 = { class: "upload-inner" }

import { uploadImg, delImgApi, addOpinion, getDict } from "@/api/common.js"
import { ref, reactive, onMounted } from 'vue';
import { ElMessage } from 'element-plus'

export default /*@__PURE__*/_defineComponent({
  __name: 'feedbackDialog',
  props: {
    popupShow: {
        type: Boolean,
        default: false
    }
},
  emits: ['close'],
  setup(__props, { emit: __emit }) {

const props = __props
const dialogShow = ref(props.popupShow)
const loginRef = ref()
const formData = ref({
    opinionType: '',
    opinionContent: ''
})
const opinionTypeList = ref([])
const fileList = ref([])
const previewFileArr = ref([])
const fileArr = []
const previewIndex = ref(0)
const showPreview = ref(false)
const emitList = __emit
const formRules = {
    opinionContent: [
        {
            message: '请填写反馈内容',
            required: true
        }
    ],
    opinionType: [
        {
            message: '请选择问题类型',
            required: true
        }
    ]
}

function submitEvent() {
    loginRef.value.validate(valid => {
        if (valid) {
            console.log(formData.value)
            let params = {
                opinionContent: formData.value.opinionContent,
                opinionType: formData.value.opinionType,
                opinionFileIds: fileArr.map(item => {
                    return item.fileId
                }).join(',')
            }
            addOpinion(params).then(res => {
                console.log(res)
                ElMessage.success('提交成功')
                emitList('close')

            }).catch(err => {
                console.log(err)
            })
        }
    })
}

function httpRequest(params) {
    const fileInfo = new FormData()
    fileInfo.append('file', params.file)
    uploadImg(fileInfo).then(res => {
        fileArr.push(res.data)
        previewFileArr.value.push(res.data.fileUrl)
        fileList.value[fileList.value.length - 1]['fileId'] = res.data.fileId;
    })
}

function handlePictureCardPreview(file) {
    previewIndex.value = fileArr.findIndex(item => {
        return item.fileId == file.fileId
    })
    showPreview.value = true;
}

function handleRemove(file) {
    if (file.fileId) {
        const index = fileArr.findIndex(item => {
            return item.fileId == file.fileId
        })
        delImgApi(file.fileId).then(res => {
            ElMessage.success('删除成功')
            fileArr.splice(index, 1)
            previewFileArr.value.splice(index, 1)
        })
    }
}

function getDictList() {
    getDict({
        dicCode: 'dd_opinion_type'
    }).then(res => {
        opinionTypeList.value = res.data || []
    })
}

function closeEvent() {
    emitList('close')
}

onMounted(() => {
    getDictList()
})


return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_Camera = _resolveComponent("Camera")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_image_viewer = _resolveComponent("el-image-viewer")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: dialogShow.value,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((dialogShow).value = $event)),
    width: "360px",
    title: "意见反馈",
    center: "",
    onClose: closeEvent
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_form, {
            ref_key: "loginRef",
            ref: loginRef,
            model: formData.value,
            rules: formRules
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, { prop: "opinionType" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: formData.value.opinionType,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.opinionType) = $event)),
                            placeholder: "选择反馈的问题类型"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(opinionTypeList.value, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  label: item.dicItemName,
                                  value: item.dicItemCode,
                                  key: item.dicItemCode
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, { prop: "opinionContent" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            type: "textarea",
                            rows: 4,
                            modelValue: formData.value.opinionContent,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.opinionContent) = $event)),
                            placeholder: "请详细描述您要反馈的内容"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _cache[5] || (_cache[5] = _createElementVNode("div", { class: "correct-tip" }, [
                _createElementVNode("span", null, "上传图片(最多5张)")
              ], -1)),
              _createVNode(_component_el_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_upload, {
                            class: "upload-box",
                            "file-list": fileList.value,
                            "onUpdate:fileList": _cache[2] || (_cache[2] = ($event: any) => ((fileList).value = $event)),
                            action: "#",
                            max: 5,
                            "list-type": "picture-card",
                            "http-request": httpRequest,
                            "on-preview": handlePictureCardPreview,
                            "on-remove": handleRemove
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_3, [
                                _createElementVNode("div", null, [
                                  _createVNode(_component_el_icon, { size: "24" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_Camera)
                                    ]),
                                    _: 1
                                  })
                                ])
                              ])
                            ]),
                            _: 1
                          }, 8, ["file-list"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1,
            __: [5]
          }, 8, ["model"])
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_el_button, {
            style: {"width":"100%"},
            color: "#ef8b25",
            class: "footer-btn1",
            onClick: submitEvent
          }, {
            default: _withCtx(() => _cache[6] || (_cache[6] = [
              _createTextVNode("提交")
            ])),
            _: 1,
            __: [6]
          })
        ]),
        (showPreview.value)
          ? (_openBlock(), _createBlock(_component_el_image_viewer, {
              key: 0,
              "url-list": previewFileArr.value,
              "show-progress": "",
              "initial-index": previewIndex.value,
              onClose: _cache[3] || (_cache[3] = ($event: any) => (showPreview.value = false))
            }, null, 8, ["url-list", "initial-index"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})